import { Tooltip } from 'antd';

import { AlertCircle } from 'lucide-react';

import { Card } from 'components/ui/card';

interface DoubleSectionProps {
  bottomTitle: string;
  bottomValue: string | number;
  topValue: string | number;
  topTitle: string;
  tooltip?: string;
}

export default function DoubleSection({ tooltip, bottomTitle, bottomValue, topTitle, topValue }: DoubleSectionProps) {
  return (
    <Card className="p-4">
      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-500 flex items-center">
          {topTitle}

          {tooltip && (
            <Tooltip title={tooltip}>
              <AlertCircle className="ml-2" size={14} />
            </Tooltip>
          )}
        </span>
      </div>
      <div className="mt-1">
        <p className="text-2xl font-bold">{topValue}</p>
        <p className="text-sm text-gray-500">
          {bottomValue} {bottomTitle}
        </p>
      </div>
    </Card>
  );
}
